import { getAppStore } from '../../store';
export const RESIZE_HANDLER_SIZE = '4px';
export function bindResizeHandler(interact, resizeRef, dialogJson, browserSizeMode, getAppConfigAction) {
    let dw;
    let dh;
    let dwForEnd;
    let dhForEnd;
    let initWidth;
    let initHeight;
    const dialogSizeMode = dialogJson.sizeMode[browserSizeMode];
    const isRTL = getAppStore().getState().appContext.isRTL;
    const dialogElement = document.querySelector(`div[id="${dialogJson.id}"] .app-dialog-content`);
    const resizeHandler = (dialogElement.querySelector('div.app-dialog-resize-handlers'));
    const leftHandler = resizeHandler.querySelector('span.dialog-resize-left');
    const rightHandler = resizeHandler.querySelector('span.dialog-resize-right');
    const topHandler = resizeHandler.querySelector('span.dialog-resize-top');
    const bottomHandler = resizeHandler.querySelector('span.dialog-resize-bottom');
    const edges = {};
    if (leftHandler) {
        edges.left = '.dialog-resize-left';
    }
    if (rightHandler) {
        edges.right = '.dialog-resize-right';
    }
    if (topHandler) {
        edges.top = '.dialog-resize-top';
    }
    if (bottomHandler) {
        edges.bottom = '.dialog-resize-bottom';
    }
    const originW = dialogSizeMode.widthMode === 'CUSTOM' &&
        parseFloat(dialogSizeMode.width.includes('%') ? dialogSizeMode.width.split('%')[0] : dialogSizeMode.width.split('px')[0]);
    const originH = dialogSizeMode.heightMode === 'CUSTOM' &&
        parseFloat(dialogSizeMode.height.includes('%') ? dialogSizeMode.height.split('%')[0] : dialogSizeMode.height.split('px')[0]);
    return interact(resizeRef)
        .resizable({
        edges: edges
    })
        .on('resizestart', event => {
        event.stopPropagation();
        dw = 0;
        dh = 0;
        const size = resizeRef.getBoundingClientRect();
        initWidth = size.width;
        initHeight = size.height;
        resizeRef.style.minWidth = '0px';
        resizeRef.style.minHeight = '0px';
    })
        .on('resizemove', (event, ui) => {
        event.stopPropagation();
        const deltaRect = event.deltaRect;
        dw += deltaRect.width * (isRTL ? -1 : 1);
        dh += deltaRect.height;
        dwForEnd = dw;
        dhForEnd = dh;
        const w = originW && `${initWidth + dw}px`;
        const h = originH && `${initHeight + dh}px`;
        resizeRef.style.width = w;
        resizeRef.style.height = h;
        if (dialogSizeMode.widthMode === 'CUSTOM') {
            dialogElement.style.width = w;
        }
        else {
            const direction = event.edges.left ? 'left' : 'right';
            const isPx = dialogSizeMode[direction].includes('px');
            let value = parseFloat(dialogSizeMode[direction].split('px')[0]);
            if (isPx) {
                value = Math.max(0, value - dw) + 'px';
            }
            else {
                value = Math.max(0, value - dw / document.body.clientWidth * 100) + '%';
            }
            dialogElement.style[direction] = value;
        }
        if (dialogSizeMode.heightMode === 'CUSTOM') {
            dialogElement.style.height = h;
        }
        else {
            const direction = event.edges.top ? 'top' : 'bottom';
            const isPx = dialogSizeMode[direction].includes('px');
            let value = parseFloat(dialogSizeMode[direction].split('px')[0]);
            if (isPx) {
                value = Math.max(0, value - dh) + 'px';
            }
            else {
                value = Math.max(0, value - dh / document.body.clientHeight * 100) + '%';
            }
            dialogElement.style[direction] = value;
        }
        if (topHandler) {
            topHandler.style.width = w;
        }
        if (bottomHandler) {
            bottomHandler.style.width = w;
        }
        if (leftHandler) {
            leftHandler.style.height = h;
        }
        if (rightHandler) {
            rightHandler.style.height = h;
        }
    })
        .on('resizeend', event => {
        event.stopPropagation();
        // Get latest dialog json to update new size.
        const latestDlgJson = getAppStore().getState().appConfig.dialogs[getAppStore().getState().appRuntimeInfo.currentDialogId];
        let newDialogJson = latestDlgJson;
        resizeRef.style.width = null;
        resizeRef.style.minWidth = null;
        resizeRef.style.height = null;
        resizeRef.style.minHeight = null;
        // Calculate new size for custom mode, new position for stretch mode
        if (dialogSizeMode.widthMode === 'CUSTOM') {
            dialogElement.style.width = null;
            const wUnit = dialogSizeMode.width.includes('px') ? 'px' : '%';
            const newWidth = getFormattedValue(wUnit, originW * (initWidth + dwForEnd) / initWidth);
            newDialogJson = newDialogJson.setIn(['sizeMode', browserSizeMode, 'width'], newWidth);
        }
        else {
            const direction = event.edges.left ? 'left' : 'right';
            newDialogJson = newDialogJson.setIn(['sizeMode', browserSizeMode, direction], dialogElement.style[direction]);
            dialogElement.style[direction] = null;
        }
        if (dialogSizeMode.heightMode === 'CUSTOM') {
            dialogElement.style.height = null;
            const hUnit = dialogSizeMode.height.includes('px') ? 'px' : '%';
            const newHeight = getFormattedValue(hUnit, originH * (initHeight + dhForEnd) / initHeight);
            newDialogJson = newDialogJson.setIn(['sizeMode', browserSizeMode, 'height'], newHeight);
        }
        else {
            const direction = event.edges.top ? 'top' : 'bottom';
            newDialogJson = newDialogJson.setIn(['sizeMode', browserSizeMode, direction], dialogElement.style[direction]);
            dialogElement.style[direction] = null;
        }
        if (topHandler) {
            topHandler.style.width = null;
        }
        if (bottomHandler) {
            bottomHandler.style.width = null;
            bottomHandler.style.top = null;
        }
        if (leftHandler) {
            leftHandler.style.height = null;
        }
        if (rightHandler) {
            rightHandler.style.height = null;
        }
        getAppConfigAction().editDialog(newDialogJson).exec();
    });
}
function getFormattedValue(unit, value) {
    return value.toFixed(unit === 'px' ? 0 : 1) + unit;
}
